var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Transition", { attrs: { name: "radial-vue-radial-menu-item" } }, [
    _c(
      "div",
      {
        staticClass: "vue-radial-menu-item",
        style: _vm.style,
        on: { click: _vm.handleClick }
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }